import { LoqateCountries } from '@/enums/loqate'
import { CountryCodes, FormFields } from '@/enums/general'

export const mapLoqateResponseToSignupState = (props = {}, country = 'nl') => {
  let streetType = ''
  let region = props.ProvinceName
  let building = `${props.BuildingName ? `${props.BuildingName} ` : ''}${props.SubBuilding}`
  let floor = props.Department
  let houseNumber = props.BuildingNumber

  if (country === CountryCodes.spain) {
    const streetTypeOptions = FormFields[country].fields.find(field => field.model === 'streetType').options
    streetType = streetTypeOptions.find(streetType => props.Street.includes(streetType)) || ''

    if (props.SubBuilding) {
      const hasFloorAndHouseNumber = props.SubBuilding.split(' ').length > 1

      if (hasFloorAndHouseNumber) {
        const [floorValue, houseNumberValue] = props.SubBuilding.split(' ')

        floor = floorValue.replace('º', '')
        houseNumber = houseNumberValue
        building = props.BuildingNumber
      } else {
        building = props.SubBuilding
        houseNumber = props.BuildingNumber
      }
    }
  }

  if (country === CountryCodes.ireland) {
    region = props.District
  }

  if (country === CountryCodes.portugal) {
    region = props.Province || props.ProvinceName
  }

  return {
    streetType,
    building,
    floor,
    street: props.Street.replace(streetType, ''),
    houseNumber,
    postalCode: props.PostalCode,
    city: props.City,
    region
  }
}

export const minimumLoqateMatchScore = 93

// https://support.loqate.com/documentation/reportcodes/address-verification-code/
export const isValidMatch = (avc = '') => {
  const isVerified = avc[0] === 'V'
  const isPartiallyVerified = avc[0] === 'P'

  const isQualityOutput = avc[1] === '4' || avc[1] === '5'

  const isOrIsAboveMinimumMatchScore = parseInt(avc.slice(-3)) >= minimumLoqateMatchScore

  const isValid = (isVerified || isPartiallyVerified) && isQualityOutput && isOrIsAboveMinimumMatchScore

  return isValid
}

export const isLoqateCountry = (country = CountryCodes.france) => {
  return LoqateCountries.includes(country)
}
